var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_4241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 36V38C42 40.21 40.21 42 38 42H4C1.79 42 0 40.21 0 38V10C0 7.79 1.79 6 4 6H38C40.21 6 42 7.79 42 10V12H24C21.79 12 20 13.79 20 16V32C20 34.21 21.79 36 24 36H42ZM24 32H44V16H24V32ZM32 27C30.34 27 29 25.66 29 24C29 22.34 30.34 21 32 21C33.66 21 35 22.34 35 24C35 25.66 33.66 27 32 27Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_4241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/PaymentIcon.c03f5bfa53aa78bfa51373119f7acf43.svg";
export { ForwardRef as ReactComponent };